/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useCallback, useMemo, useRef } from 'react';
import { useModel } from 'umi';
import { usePrevious } from 'ahooks';
import * as apis from '../apis/apis';
import {
  watchdogPercentEventSuccess,
  watchdogPercentEventFail,
} from '@/utils/watchdog-percent';
import { VehicleTypeKV } from '@/constant/vechicle-type-dict';
import useLatest from '@/ahooks/use-latest';
import type { CityInfoConfigType } from '@/pages/order-center/city-info-config.types';
import { MessageError } from '@/components';
import { log } from '@/utils/log';

type CityInfoType = {
  specReqItem: [];
  revision: '';
  cityId: number;
  porterageItem: {
    driverConfer: number; // 搬运服务司机另议是否展示 0否 1是
  };
  vehicleItem?: [];
};

let resNewCityInfoLoading = false;
type CityInfoFlagType = { id: string; status: 'start' | 'success' | 'error' };
export default function OrderCenterSameCityShippingCity() {
  const [vehicleList, setVehicleList] = useState<any[]>([]); // 车型列表
  const [demand, setDemand] = useState<string[]>([]); // 选中的对应要求
  const [demandList, setDemandList] = useState<any[]>([]); // 车型对应车辆要求列表
  const [cityInfo, setCityInfo] = useState<CityInfoType>({
    specReqItem: [],
    revision: '',
    cityId: 0,
    porterageItem: {
      driverConfer: 0,
    },
  }); // 城市对应信息
  const [selectedVehicleId, setSelectedVehicleId] = useState<
    number | undefined
  >(); // 选中车型id
  const [selectedVehicle, setSelecetedVehicle] = useState<any>({}); // 选中车型对象
  const [isBigVehicle, setIsBigVehicle] = useState<number>(0); // 是否大车
  const prevIsBigVehicle = usePrevious(isBigVehicle); // 保存上次的大小车
  const [initData, setInitData] = useState<any>(); // 默认值
  const [resetSign, setResetSigh] = useState<boolean>(false); // 重置标识
  const { isClearType } = useModel('common');
  const [originCityInfoConfig, setOriginCityInfoConfig] = useState<CityInfoConfigType>();
  const cityInfoFlagRef = useRef<CityInfoFlagType>();

  const selectedVehicleRef = useLatest(selectedVehicle);
  const isClearTypeRef = useLatest(isClearType); 



  const resNewCityInfo = async (params: { city_id: number; flag: CityInfoFlagType }) => {

    try {
      const res = await apis.getCityInfoBeta({ city_id: params.city_id });
      const { ret, msg, data } = res || {}
      if (ret=== 0) {
        // 丢弃过期响应：如果在本次请求之后又发起了新的 getCityInfo，则忽略本次结果
        if (cityInfoFlagRef.current?.id !== params.flag.id) {
          log.log('getCityInfoBeta丢弃过期响应', params.flag.id);
          resNewCityInfoLoading = false;
          return;
        }
        watchdogPercentEventSuccess('城市车型接口');

        if (!data.cityInfoItem.vehicleItem.length) {
          setSelectedVehicleId(undefined);
          setIsBigVehicle(0);
        }
        setCityInfo(data.cityInfoItem);
        let vehicleItem = data.cityInfoItem?.vehicleItem;
        // 非清分-承运不展示三轮、4轮轿车
        if (!isClearTypeRef?.current) {
          vehicleItem = (data.cityInfoItem?.vehicleItem || []).filter(
            (item: any) => {
              return ![
                VehicleTypeKV.WHEEL3,
                VehicleTypeKV.WHEEL4SEDAN,
              ].includes(item.vehicleType);
            }
          );
        }
        setVehicleList(vehicleItem);
        setOriginCityInfoConfig(data.cityInfoItem);
        // const currentRequestFlag: CityInfoFlagType = params?.[0]?.flag;
        cityInfoFlagRef.current = { ...params.flag, status: 'success' };

        resNewCityInfoLoading = false;
      } else {
        resNewCityInfoLoading = false;
        cityInfoFlagRef.current = { ...params.flag, status: 'error' };
        watchdogPercentEventFail('城市车型接口', {
          message: msg,
        });
        MessageError(msg);
      }
    } catch (error) {
      console.log('error::::::::::;', error);
      cityInfoFlagRef.current = { ...params.flag, status: 'error'};
      resNewCityInfoLoading = false;
      watchdogPercentEventFail('城市车型接口', {
        // message: error?.message,
      });
    }
  }
  // const resNewCityInfo1 = useRequest((params: { city_id: number; flag: CityInfoFlagType }) => apis.getCityInfoBeta({ city_id: params.city_id }), {
  //   manual: true,
  //   onSuccess: (data, params) => {
  //     console.log('onsuccess::::::::::;', params, data);
  //     watchdogPercentEventSuccess('城市车型接口');

  //     if (!data.cityInfoItem.vehicleItem.length) {
  //       setSelectedVehicleId(undefined);
  //       setIsBigVehicle(0);
  //     }
  //     setCityInfo(data.cityInfoItem);
  //     let vehicleItem = data.cityInfoItem?.vehicleItem;
  //     // 非清分-承运不展示三轮、4轮轿车
  //     if (!isClearType) {
  //       vehicleItem = (data.cityInfoItem?.vehicleItem || []).filter(
  //         (item: any) => {
  //           return ![
  //             VehicleTypeKV.WHEEL3,
  //             VehicleTypeKV.WHEEL4SEDAN,
  //           ].includes(item.vehicleType);
  //         }
  //       );
  //     }
  //     setVehicleList(vehicleItem);
  //     setOriginCityInfoConfig(data.cityInfoItem);
  //     const currentRequestFlag: CityInfoFlagType = params?.[0]?.flag;
  //     cityInfoFlagRef.current = { ...currentRequestFlag, status: 'success' };

  //     resNewCityInfoLoading = false;
  //   },
  //   onError: (error, params) => {
  //     console.log('onerror::::::::::;', params);
  //     const currentRequestFlag: CityInfoFlagType = params?.[0]?.flag;
  //     cityInfoFlagRef.current = { ...currentRequestFlag, status: 'error' };
  //     resNewCityInfoLoading = false;
  //     watchdogPercentEventFail('城市车型接口', {
  //       message: error?.message,
  //     });
  //   },
  // });
  const setSelectedVehicleIdCb = useCallback((val) => {
    setSelectedVehicleId(val);
  }, []);
  const getCityInfo = (city_id: number) => {
    resNewCityInfoLoading = true;
    const newFlag: CityInfoFlagType = { id: `${city_id}-${Date.now()}`, status: 'start' };
    cityInfoFlagRef.current = newFlag;
    resNewCityInfo({ city_id, flag: newFlag });
  };
  const setDemandCb = useCallback((val) => {
    setDemand(val);
  }, []);
  const setDemandListCb = useCallback((val) => {
    setDemandList(val);
  }, []);
  const setIsBigVehicleCb = useCallback((val) => {
    setIsBigVehicle(val);
  }, []);
  const setSelectedVehicleCb = useCallback((val) => {
    selectedVehicleRef.current = val;
    setSelecetedVehicle(val);
  }, []);
  const set = useCallback((val) => {
    setInitData(val);
  }, []);
  const reset = useCallback(() => {
    setResetSigh(true);
  }, []);
  const setResetSighCb = useCallback((val) => {
    setResetSigh(val);
  }, []);

  // 是否是四轮小件车型
  const isFourWheels = useMemo(() => {
    return selectedVehicle?.vehicleType === VehicleTypeKV.WHEEL4SEDAN;
  }, [selectedVehicle]);

  const getResNewCityInfoLoading = () => {
    return resNewCityInfoLoading;
  };
  return {
    demand,
    vehicleList,
    selectedVehicleId,
    cityInfo,
    demandList,
    isBigVehicle,
    prevIsBigVehicle,
    initData,
    selectedVehicle,
    resetSign,
    getResNewCityInfoLoading,
    setSelectedVehicleIdCb,
    getCityInfo,
    setDemandCb,
    setDemandListCb,
    setIsBigVehicleCb,
    setSelectedVehicleCb,
    selectedVehicleRef,
    set,
    reset,
    setResetSighCb,
    isFourWheels,
    originCityInfoConfig,
    cityInfoFlagRef,
  };
}
